<template>
  <div class="breadcrumb-container">
    <div class="breadcrumb-content">
      <template v-for="(item, index) in items" :key="index">
        <router-link v-if="item.path" :to="item.path">{{
          item.label
        }}</router-link>
        <span v-else>{{ item.label }}</span>
        <span v-if="index < items.length - 1" class="separator">&gt;</span>
      </template>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
    // Example: [{ label: '首頁', path: '/' }, { label: '簡介與沿革' }]
  },
});
</script>

<style scoped lang="scss">
.breadcrumb-container {
  width: 100%;
  height: 64px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.breadcrumb-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #696969;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  min-width: max-content;

  a {
    color: #696969;
    text-decoration: none;
    transition: color 0.3s;
    white-space: nowrap;

    &:hover {
      color: #184387;
    }
  }

  span {
    white-space: nowrap;
  }

  .separator {
    margin: 0 8px;
    color: #696969;
    flex: 0 0 auto;
  }
}
</style>
